(function () {
    'use strict';

    var STORAGE_KEY = 'techlight_selected_products';

    // ─────────────────────────────────────────────
    // SessionStorage helpers
    // ─────────────────────────────────────────────

    function getSelected() {
        try {
            var raw = sessionStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch (e) {
            return {};
        }
    }

    function saveSelected(data) {
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {
        }
    }

    function clearSelected() {
        sessionStorage.removeItem(STORAGE_KEY);
    }

    // ─────────────────────────────────────────────
    // Zbierz dane wariantów z wiersza DOM
    // ─────────────────────────────────────────────

    function collectVariantsFromRow(row) {
        var variants = [];
        var variationItems = row.querySelectorAll('.variation-item');

        variationItems.forEach(function (item) {
            var cols = item.querySelectorAll('[class*="col-"]');

            // Kolejność kolumn: SKU | Długość | Kolor | Cena
            var sku     = cols[0] ? cols[0].textContent.trim() : '';
            var dlugosc = cols[1] ? cols[1].textContent.trim() : '';
            var kolorEl = cols[2] ? cols[2].textContent.trim() : '';
            var cena    = cols[3] ? cols[3].textContent.trim() : '';

            // Pobierz kolor hex ze swatch jeśli istnieje
            var swatchEl = cols[2] ? cols[2].querySelector('.tl-color-swatch') : null;
            var kolorHex = '';
            if (swatchEl) {
                kolorHex = swatchEl.style.backgroundColor || '';
            }
            // Zbierz nazwy z .tl-kolor-name (może być kilka)
            var kolorNameEls = cols[2] ? cols[2].querySelectorAll('.tl-kolor-name') : [];
            if (kolorNameEls.length > 0) {
                var names = [];
                kolorNameEls.forEach(function(el) { names.push(el.textContent.trim()); });
                kolorEl = names.join(', ');
            }

            variants.push({
                sku: sku,
                kolor: kolorEl,
                kolorHex: kolorHex,
                dlugosc: dlugosc,
                cena: cena
            });
        });

        return variants;
    }

    // ─────────────────────────────────────────────
    // Zbierz pełne dane z wiersza
    // ─────────────────────────────────────────────

    function collectRowData(row) {
        var skuKey = row.dataset.sku || '';
        var title = row.dataset.title || '';
        var category = row.dataset.category || '';
        var variants = collectVariantsFromRow(row);

        // Zdjęcie produktu
        var imgEl = row.querySelector('.col-1 img.img-fluid');
        var image = imgEl ? imgEl.src : '';

        // Zdjęcie wymiarów (drugi col-1)
        var allCol1 = row.querySelectorAll('.col-1');
        var wymiarImg = allCol1[1] ? allCol1[1].querySelector('img') : null;
        var wymiary = wymiarImg ? wymiarImg.src : '';

        return {
            skuKey: skuKey,
            title: title,
            category: category,
            image: image,
            wymiary: wymiary,
            variants: variants
        };
    }

    // ─────────────────────────────────────────────
    // Info w modalu – ile produktów zostanie wygenerowane
    // ─────────────────────────────────────────────

    function updateScopeInfo(infoId) {
        var infoEl = document.getElementById(infoId || 'tl-cennik-scope-info');
        if (!infoEl) return;

        var i18n     = window.techlightI18n || {};
        var selected = getSelected();
        var count    = Object.keys(selected).length;

        if (count > 0) {
            var tpl;
            if (count === 1) {
                tpl = i18n.scopeSelectedSingle || '✓ Zaznaczono 1 produkt – zostanie wygenerowany cennik tylko dla zaznaczonych.';
            } else if (count < 5) {
                tpl = i18n.scopeSelectedFew || '✓ Zaznaczono %d produkty – zostanie wygenerowany cennik tylko dla zaznaczonych.';
            } else {
                tpl = i18n.scopeSelectedMany || '✓ Zaznaczono %d produktów – zostanie wygenerowany cennik tylko dla zaznaczonych.';
            }
            infoEl.className     = 'alert alert-warning mb-4';
            infoEl.style.display = '';
            infoEl.textContent   = tpl.replace('%d', count);
        } else {
            infoEl.className     = 'alert alert-info mb-4';
            infoEl.style.display = '';
            infoEl.textContent   = i18n.scopeNoSelection || 'Brak zaznaczonych produktów – zostanie wygenerowany pełny cennik (aktualny filtr).';
        }
    }

    // ─────────────────────────────────────────────
    // Zaktualizuj licznik zaznaczonych
    // ─────────────────────────────────────────────

    function updateCounter() {
        var selected = getSelected();
        var count = Object.keys(selected).length;

        var counters = document.querySelectorAll('.tl-selected-count');
        counters.forEach(function (el) {
            el.textContent = count > 0 ? '(' + count + ')' : '';
        });

        // btn-generate-cennik zawsze aktywny
        // btn-generate-cennik-klient aktywny tylko gdy coś zaznaczone
        document.querySelectorAll('.btn-generate-cennik-klient').forEach(function (btn) {
            btn.disabled = false;
        });
        document.querySelectorAll('.btn-generate-cennik').forEach(function (btn) {
            btn.disabled = false;
        });
    }

    // ─────────────────────────────────────────────
    // Przywróć stan checkboxów po załadowaniu strony
    // ─────────────────────────────────────────────

    function restoreCheckboxes() {
        // Sprawdź czy język się zmienił - jeśli tak, wyczyść sessionStorage
        var currentLang = document.documentElement.lang || 'pl-PL';
        var langCode = currentLang.split('-')[0].toLowerCase();
        var savedLang = sessionStorage.getItem('techlight_page_lang');
        
        if (savedLang && savedLang !== langCode) {
            console.log('🔄 Techlight: Język zmieniony z', savedLang, 'na', langCode, '- czyszczę zaznaczenia');
            clearSelected(); // Wyczyść sessionStorage
            sessionStorage.setItem('techlight_page_lang', langCode);
            updateCounter();
            syncMasterCheckbox();
            return; // Nie przywracaj checkboxów
        }
        
        // Zapisz aktualny język
        sessionStorage.setItem('techlight_page_lang', langCode);
        
        // Przywróć checkboxy normalnie
        var selected = getSelected();
        var rows = document.querySelectorAll('.product-main-row');

        rows.forEach(function (row, i) {
            var skuKey = row.dataset.sku || row.dataset.title || ('row_' + i);

            var checkbox = row.querySelector('.techlight-checkbox');
            if (checkbox && selected.hasOwnProperty(skuKey)) {
                checkbox.checked = true;
            }
        });

        updateCounter();
        syncMasterCheckbox();
        
        // Pokaż przycisk "Odznacz wszystko" jeśli są zaznaczone checkboxy
        if (typeof window.updateUncheckButtonVisibility === 'function') {
            window.updateUncheckButtonVisibility();
        }
    }

    // ─────────────────────────────────────────────
    // Synchronizuj master checkbox w nagłówku
    // ─────────────────────────────────────────────

    function syncMasterCheckbox() {
        var masterCheckbox = document.querySelector('.table-thead .techlight-checkbox');
        if (!masterCheckbox) return;

        var childCheckboxes = document.querySelectorAll('.product-group-box .techlight-checkbox');
        var allChecked = childCheckboxes.length > 0;

        childCheckboxes.forEach(function (cb) {
            if (!cb.checked) allChecked = false;
        });

        masterCheckbox.checked = allChecked;
    }

    // ─────────────────────────────────────────────
    // Obsługa zmiany checkboxa produktu
    // ─────────────────────────────────────────────

    function handleCheckboxChange(row, isChecked) {
        var skuKey = row.dataset.sku || row.dataset.title || '';
        if (!skuKey) {
            // Fallback – użyj indeksu wiersza w DOM
            var rows = document.querySelectorAll('.product-main-row');
            rows.forEach(function (r, i) { if (r === row) skuKey = 'row_' + i; });
        }
        if (!skuKey) return;

        var selected = getSelected();

        if (isChecked) {
            selected[skuKey] = collectRowData(row);
        } else {
            delete selected[skuKey];
        }

        saveSelected(selected);
        updateCounter();
        syncMasterCheckbox();
        
        // Pokaż przycisk "Odznacz wszystko" jeśli są zaznaczone checkboxy
        if (typeof window.updateUncheckButtonVisibility === 'function') {
            window.updateUncheckButtonVisibility();
        }
    }

    // ─────────────────────────────────────────────
    // Obsługa master checkboxa (zaznacz wszystkie)
    // ─────────────────────────────────────────────

    function handleMasterCheckboxChange(isChecked) {
        var rows = document.querySelectorAll('.product-group-box .product-main-row');
        var selected = getSelected();

        rows.forEach(function (row, i) {
            var skuKey = row.dataset.sku || row.dataset.title || ('row_' + i);

            var checkbox = row.querySelector('.techlight-checkbox');
            if (checkbox) checkbox.checked = isChecked;

            if (isChecked) {
                selected[skuKey] = collectRowData(row);
            } else {
                delete selected[skuKey];
            }
        });

        saveSelected(selected);
        updateCounter();
    }

    // ─────────────────────────────────────────────
    // Podepnij eventy
    // ─────────────────────────────────────────────

    function bindEvents() {
        // Delegacja na document – przeżywa podmianę DOM przez Filter Everything
        document.addEventListener('change', function (e) {
            var checkbox = e.target;
            if (!checkbox.classList.contains('techlight-checkbox')) return;

            var isInHeader = checkbox.closest('.table-thead') !== null;

            if (isInHeader) {
                handleMasterCheckboxChange(checkbox.checked);
            } else {
                var row = checkbox.closest('.product-main-row');
                if (row) handleCheckboxChange(row, checkbox.checked);
            }
        });
    }

    // ─────────────────────────────────────────────
    // Publiczne API – eksport do window
    // ─────────────────────────────────────────────

    window.TechlightGenerate = {
        getSelected: getSelected,
        clearSelected: clearSelected,
        updateCounter: updateCounter
    };

    // ─────────────────────────────────────────────
    // Generowanie PDF – wysyłka AJAX
    // ─────────────────────────────────────────────

    function showLoader(message) {
        var existing = document.getElementById('tl-loader-overlay');
        if (existing) return;

        var overlay = document.createElement('div');
        overlay.id = 'tl-loader-overlay';
        overlay.style.cssText = [
            'position:fixed', 'inset:0', 'z-index:99999',
            'background:rgba(0,0,0,0.55)',
            'display:flex', 'flex-direction:column',
            'align-items:center', 'justify-content:center',
            'gap:18px'
        ].join(';');

        overlay.innerHTML =
            '<div style="width:56px;height:56px;border:5px solid rgba(255,255,255,0.25);border-top-color:#FFD700;border-radius:50%;animation:tl-spin 0.8s linear infinite;"></div>' +
            '<div style="color:#fff;font-size:15px;font-weight:600;letter-spacing:0.02em;">' + (message || 'Generowanie…') + '</div>' +
            '<div style="color:rgba(255,255,255,0.6);font-size:12px;">To może potrwać kilka sekund…</div>';

        if (!document.getElementById('tl-loader-style')) {
            var style = document.createElement('style');
            style.id = 'tl-loader-style';
            style.textContent = '@keyframes tl-spin{to{transform:rotate(360deg)}}';
            document.head.appendChild(style);
        }

        document.body.appendChild(overlay);
    }

    function hideLoader() {
        var el = document.getElementById('tl-loader-overlay');
        if (el) el.parentNode.removeChild(el);
    }



    function sendGenerateRequest(companyName, btnEl) {
        var selected = getSelected();
        var hasSelected = Object.keys(selected).length > 0;

        var formatEl = document.querySelector('input[name="cennik_format"]:checked');
        var format   = formatEl ? formatEl.value : 'pdf';

        var originalText  = btnEl.textContent;
        btnEl.disabled    = true;
        btnEl.textContent = 'Generowanie…';

        var formatLabels = { pdf: 'Generowanie PDF…', csv: 'Generowanie CSV…', excel: 'Generowanie Excel…' };
        showLoader(formatLabels[format] || 'Generowanie…');

        var pdf      = window.TechlightPDF || {};
        var formData = new FormData();
        formData.append('action',       'techlight_generate_pdf');
        formData.append('nonce',        pdf.nonce    || '');
        formData.append('lang',         pdf.lang     || document.documentElement.lang.split('-')[0] || 'pl');
        formData.append('currency',     pdf.currency || 'PLN');
        formData.append('company_name', companyName);
        formData.append('format',       format);

        if (hasSelected) {
            formData.append('products', JSON.stringify(Object.values(selected)));
        } else {
            // Brak zaznaczonych – generuj wszystkie z aktualnego filtra
            formData.append('all_from_filter', '1');
            // Przekaż aktualne parametry GET (filtry, wyszukiwanie)
            var filterParams = {};
            var search = window.location.search.slice(1);
            if (search) {
                search.split('&').forEach(function (part) {
                    var pair = part.split('=');
                    if (pair.length === 2) {
                        var key = decodeURIComponent(pair[0]);
                        var val = decodeURIComponent(pair[1].replace(/\+/g, ' '));
                        // Pomiń parametry paginacji
                        if (key !== 'paged') {
                            if (filterParams[key]) {
                                if (!Array.isArray(filterParams[key])) filterParams[key] = [filterParams[key]];
                                filterParams[key].push(val);
                            } else {
                                filterParams[key] = val;
                            }
                        }
                    }
                });
            }
            formData.append('filter_params', JSON.stringify(filterParams));
        }

        fetch((window.TechlightPDF || {}).ajaxurl || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body:   formData,
        })
        .then(function (res) { return res.json(); })
        .then(function (json) {
            if (json.success) {
                var mimeMap = { pdf: 'application/pdf', csv: 'text/csv', excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
                var mime    = mimeMap[json.data.format] || 'application/pdf';
                triggerDownloadRaw(json.data.filename, json.data.data, mime);
                var openModal = document.querySelector('.modal.show');
                if (openModal) {
                    var ModalClass = (window.understrap && window.understrap.Modal) || (window.bootstrap && window.bootstrap.Modal);
                    if (ModalClass) ModalClass.getInstance(openModal).hide();
                }
            } else {
                alert('Błąd: ' + (json.data && json.data.message ? json.data.message : 'Nieznany błąd.'));
            }
        })
        .catch(function () {
            alert('Błąd połączenia z serwerem.');
        })
        .finally(function () {
            hideLoader();
            btnEl.disabled    = false;
            btnEl.textContent = originalText;
        });
    }

    function bindModalButtons() {
        // ── Inicjalizacja popoverów (span wrapper gdy NIE) ────
        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (el) {
            var PopoverClass = (window.understrap && window.understrap.Popover) || (window.bootstrap && window.bootstrap.Popover);
            if (PopoverClass) new PopoverClass(el);
        });
        // ── Modal standardowy ──────────────────────────────
        var modalEl = document.getElementById('modalGenerujCennik');
        if (modalEl) {
            modalEl.addEventListener('show.bs.modal', function () {
                updateScopeInfo('tl-cennik-scope-info');
            });
        }

        var btnSubmit = document.getElementById('btn-generuj-cennik-submit');
        if (btnSubmit) {
            btnSubmit.addEventListener('click', function () {
                var company = document.getElementById('cennik-company');
                sendGenerateRequest(company ? company.value : '', this);
            });
        }

        // ── Modal klienta ──────────────────────────────────
        var modalKlientEl = document.getElementById('modalGenerujCennikKlient');
        if (modalKlientEl) {
            // Przy otwarciu modalu – wypełnij kategorie z zaznaczonych produktów
        modalKlientEl.addEventListener('show.bs.modal', function () {
                buildKategorieGrid();
                updateScopeInfo('tl-cennik-klient-scope-info');

                // Wypełnij pole nazwy firmy z konta użytkownika (wartość pochodzi z PHP)
                // var companyInput = document.getElementById('cennik-klient-company');
                // if (companyInput && !companyInput.value && window.TechlightPDF && window.TechlightPDF.company_name) {
                //     companyInput.value = window.TechlightPDF.company_name;
                // }
            });
        }

        var btnKlientSubmit = document.getElementById('btn-generuj-cennik-klient-submit');
        if (btnKlientSubmit) {
            btnKlientSubmit.addEventListener('click', function () {
                sendGenerateKlientRequest(this);
            });
        }
    }

    // ─────────────────────────────────────────────
    // Buduj siatkę kategorii w modalu klienta
    // ─────────────────────────────────────────────

    function buildKategorieGrid() {
        var selected  = getSelected();
        var grid      = document.getElementById('cennik-klient-kategorie-grid');
        var wrap      = document.getElementById('cennik-klient-kategorie-wrap');
        if (!grid || !wrap) return;

        // Zbierz unikalne kategorie z zaznaczonych produktów
        var categories = {};
        Object.values(selected).forEach(function (product) {
            var cat = (product.category || '').trim();
            if (cat && !categories[cat]) {
                categories[cat] = cat;
            }
        });

        var catList = Object.keys(categories).sort();

        // Nic nie zaznaczone → pokaż wszystkie kategorie z backendu
        if (catList.length === 0) {
            var allCats = (window.TechlightPDF && Array.isArray(window.TechlightPDF.all_categories))
                ? window.TechlightPDF.all_categories
                : [];
            catList = allCats.slice().sort();
        }

        if (catList.length === 0) {
            wrap.style.display = 'none';
            return;
        }

        wrap.style.display = '';
        grid.innerHTML = '';

        var marginPh = (window.techlightI18n && window.techlightI18n.marginPlaceholder) ? window.techlightI18n.marginPlaceholder : 'Wpisz wysokość marży';

        catList.forEach(function (cat) {
            var colId  = 'marza-cat-' + cat.replace(/[^a-z0-9]/gi, '-').toLowerCase();
            var col    = document.createElement('div');
            col.className = 'col-md-6';
            col.innerHTML =
                '<label for="' + colId + '" class="form-label text-muted mb-1">' + escHtml(cat) + '</label>' +
                '<input type="number" min="0" step="0.01" class="form-control tl-marza-input"' +
                '  id="' + colId + '" data-category="' + escHtml(cat) + '" placeholder="' + escHtml(marginPh) + '">';
            grid.appendChild(col);
        });
    }

    function escHtml(str) {
        return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    // ─────────────────────────────────────────────
    // Wyślij request cennika klienta (z marżą)
    // ─────────────────────────────────────────────

    function sendGenerateKlientRequest(btnEl) {
        var selected    = getSelected();
        var hasSelected = Object.keys(selected).length > 0;

        var company  = document.getElementById('cennik-klient-company');
        var marzaTyp = document.getElementById('cennik-klient-marza-typ');
        var formatEl = document.querySelector('input[name="cennik_klient_format"]:checked');
        var format   = formatEl ? formatEl.value : 'pdf';

        // Zbierz marże per kategoria
        var marze = {};
        document.querySelectorAll('.tl-marza-input').forEach(function (input) {
            var cat = input.dataset.category || '';
            var val = parseFloat(input.value);
            if (cat && !isNaN(val) && val > 0) {
                marze[cat] = val;
            }
        });

        var originalText  = btnEl.textContent;
        btnEl.disabled    = true;
        btnEl.textContent = 'Generowanie…';

        var formatLabels = { pdf: 'Generowanie PDF…', csv: 'Generowanie CSV…', excel: 'Generowanie Excel…' };
        showLoader(formatLabels[format] || 'Generowanie…');

        var pdf      = window.TechlightPDF || {};
        var formData = new FormData();
        formData.append('action',       'techlight_generate_pdf_klient');
        formData.append('nonce',        pdf.nonce    || '');
        formData.append('lang',         pdf.lang     || document.documentElement.lang.split('-')[0] || 'pl');
        formData.append('currency',     pdf.currency || 'PLN');
        formData.append('company_name', company ? company.value : '');
        formData.append('marza_typ',    marzaTyp ? marzaTyp.value : 'percent');
        formData.append('marze',        JSON.stringify(marze));
        formData.append('format',       format);

        if (hasSelected) {
            formData.append('products', JSON.stringify(Object.values(selected)));
        } else {
            formData.append('all_from_filter', '1');
            var filterParams = {};
            var search = window.location.search.slice(1);
            if (search) {
                search.split('&').forEach(function (part) {
                    var pair = part.split('=');
                    if (pair.length === 2) {
                        var key = decodeURIComponent(pair[0]);
                        var val = decodeURIComponent(pair[1].replace(/\+/g, ' '));
                        if (key !== 'paged') {
                            if (filterParams[key]) {
                                if (!Array.isArray(filterParams[key])) filterParams[key] = [filterParams[key]];
                                filterParams[key].push(val);
                            } else {
                                filterParams[key] = val;
                            }
                        }
                    }
                });
            }
            formData.append('filter_params', JSON.stringify(filterParams));
        }

        fetch(pdf.ajaxurl || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body:   formData,
        })
        .then(function (res) { return res.json(); })
        .then(function (json) {
            if (json.success) {
                var mimeMap = { pdf: 'application/pdf', csv: 'text/csv', excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
                var mime    = mimeMap[json.data.format] || 'application/pdf';
                triggerDownloadRaw(json.data.filename, json.data.data, mime);
                var openModal = document.querySelector('.modal.show');
                if (openModal) {
                    var ModalClass = (window.understrap && window.understrap.Modal) || (window.bootstrap && window.bootstrap.Modal);
                    if (ModalClass) ModalClass.getInstance(openModal).hide();
                }
            } else {
                alert('Błąd: ' + (json.data && json.data.message ? json.data.message : 'Nieznany błąd.'));
            }
        })
        .catch(function () {
            alert('Błąd połączenia z serwerem.');
        })
        .finally(function () {
            hideLoader();
            btnEl.disabled    = false;
            btnEl.textContent = originalText;
        });
    }

    function triggerDownloadRaw(filename, base64data, mime) {
        var byteChars   = atob(base64data);
        var byteNumbers = new Array(byteChars.length);
        for (var i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        var blob = new Blob([new Uint8Array(byteNumbers)], { type: mime });
        var url  = URL.createObjectURL(blob);
        var a    = document.createElement('a');
        a.href   = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    // ─────────────────────────────────────────────
    // Init
    // ─────────────────────────────────────────────

    document.addEventListener('DOMContentLoaded', function () {
        bindEvents();
        restoreCheckboxes();
        bindModalButtons();

        // Filter Everything triggeruje $(document).trigger('ready') po każdym AJAX
        // Źródło: filter-everything.js linia 1315
        if (typeof jQuery !== 'undefined') {
            jQuery(document).on('ready', function () {
                restoreCheckboxes();
            });
        }
    });

}());
